module.exports = __webpack_public_path__ + "media/customizations/icpnaples/logo-new-1e3e71c8da478ad732bf02939c2f597a.png";